import React, { useState, useRef, useEffect } from 'react';
import {map} from "lodash";

const Example2 = () => {

  return (
    <div className="email">
      <h3>Email 2</h3>
    </div>
  );
};

export default Example2;
